module.exports = __webpack_public_path__ + "img/IMG_9475-1200w.7a0a4f26.jpg";